import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilepondPluginDownloadFile from "@/helpers/filepond-plugin-download-file";
import "@/assets/css/filepond.min.css";
import "@/assets/css/filepond-plugin-get-file.css";

export default new vueFilePond(FilePondPluginFileValidateType, FilePondPluginFileValidateSize, FilepondPluginDownloadFile);



// WEBPACK FOOTER //
// ./src/plugins/filepond.js